export default class BaseView {
	constructor(container) {
		this.container = container;
		this.modules = [];
	}

	afterEnterFunctions() {
        // Scroll to target Section on page load
        if(window.location.hash) {
            this.scrollToSection(window.location.hash);
        }
    }

	handleNavClick(evt) {
		evt.preventDefault();

		const targetID = evt.target.getAttribute('data-target-section');
		this.scrollToSection('#'+targetID, 1.4);

		document.dispatchEvent(new CustomEvent('close-menu'));
	}

	destroy() {
		this.modules.forEach((module) => {
			if (typeof module.destroy !== 'function') {
				return;
			}

			module.destroy();
		});
	}
}
